import { IAppState } from '../../common/state';
import { FILTERS_REDESIGN_EXPERIMENT } from '../../constants/experiments';
import { FDealType } from '../../utils/category';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { getDealType } from '../getDealType';
import { selectExperiments } from '../selectExperiments';

export const selectFiltersRedesignExperimentActive = (state: IAppState) => {
  const experiments = selectExperiments(state);
  const dealType = getDealType(state);

  return dealType === FDealType.Sale && isAbUseExperimentGroup(experiments, FILTERS_REDESIGN_EXPERIMENT, 'B');
};
